import React from "react";

function Terms() {
    return (
        <div id="main" class="wrapper">
            <div class="inner">
                <header className="page-header">
                    <h1>Terms of Use</h1>
                    <p className="doc-meta">Last Updated: September 16, 2026</p>
                </header>
                <h2>Welcome to Reliance Litigation, LLC</h2>
                <p>
                    Thanks for using our services (“Services”). The Services are
                    provided by Reliance Litigation, LLC.
                </p>
                <p>
                    By using our Services, you are agreeing to these terms.
                    Please read them carefully.
                </p>
                <p>
                    This agreement (&ldquo;Agreement&rdquo;) is made between us
                    and you (&ldquo;you&rdquo; or &ldquo;user&rdquo;) (jointly
                    the &ldquo;parties&rdquo; and each individually a
                    &ldquo;party&rdquo;) and sets forth the terms of use that
                    apply to your access to and use of the Site or other
                    Reliance Litigation, LLC owned and operated Site(s).
                </p>
                <h2>1. Acceptance and Changes</h2>
                <p>
                    {" "}
                    By visiting or accessing the Site, you agree to be bound by
                    this Agreement. You also represent that you have not been
                    previously suspended from using the Site. You further
                    consent to the terms of our online Privacy Policy and to our
                    use and processing of any user information for the purposes
                    provided in the Privacy Policy.
                </p>
                <p>
                    Your visitation and/or use of the Site mean that you accept
                    this Agreement and the practices set forth in our Privacy
                    Policy. We reserve the right to make changes to this
                    Agreement and/or our Privacy Policy at any time. Any change
                    will become effective no sooner than 14 days after it is
                    posted, unless the change relates to the functionality of a
                    new service or a change in the law, in which case the change
                    will be effective immediately. Your continued use following
                    any effective change indicates your agreement and/or consent
                    to the change(s). It is your sole responsibility to check
                    back regularly for updates to this Agreement and our Privacy
                    Policy.
                </p>
                <p>
                    IF YOU DO NOT AGREE WITH ANY OF THESE TERMS, YOU MUST STOP
                    USING THE SITE IMMEDIATELY.
                </p>
                <h2>2. What We Do</h2>
                <p>
                    We provide marketing, advertising, and intake services to
                    law firms that pay us for those services (&ldquo;Third Party
                    Attorneys&rdquo;). Our service is free to you as a
                    prospective client. When you submit an inquiry, we may
                    contact you on behalf of the Third Party Attorneys that
                    engage our services. We generally do not provide or sell the
                    information you submit to Third Party Attorneys; instead, we
                    contact you on their behalf. To submit a request, you must
                    complete the registration that we make available on the
                    Site.
                </p>
                <h2>3. No Attorney-Client Relationship and Confidentiality</h2>
                <p>
                    You acknowledge that no attorney-client relationship is, or
                    will be, formed through the use of this Site, and that you
                    have no expectation of privacy or confidentiality of
                    communications occurring through this Site. Information
                    submitted by you to the Site is solely a request to have a
                    law firm contact you about your situation. You are under no
                    obligation to retain a lawyer who contacts you through this
                    service. We are not a party to any agreement you may enter
                    into with a Third Party Attorney, and we have no control
                    over whether a Third Party Attorney contacts you or accepts
                    you as a client. The terms and conditions of any
                    attorney-client relationship are determined solely by you
                    and the applicable Third Party Attorney, not us.
                </p>
                <h2>4. Registration, Termination and Cancellation</h2>
                <p>
                    You must provide us with complete, accurate and true
                    information. We may reject a submission or terminate/suspend
                    the registration of any user at any time in the event that
                    you breach any of your duties, obligations or
                    responsibilities under the Agreement, or for any other
                    reason in our sole discretion. Upon or following
                    termination, we shall have no liability to you or any
                    further obligations under this Agreement. You may cancel
                    your registration at any time by sending an e-mail with the
                    subject line &ldquo;CANCELLATION&rdquo; to
                    info@reliancelitigation.com. Thereafter, you will no longer
                    receive communications from us. However, you may have to
                    unsubscribe from future third party communications directly.
                </p>
                <h2>
                    5. Submission of Information and Consent to Be Contacted
                </h2>
                <p>
                    By registering on the Site, you are making an inquiry and
                    entering into a business relationship with us. Please do not
                    submit confidential or sensitive personal information on the
                    submission form. By submitting your information, you are
                    requesting that we contact you regarding your inquiry,
                    including on behalf of the law firms and Affiliates that
                    engage our services. &ldquo;Affiliate&rdquo; means any
                    business entity that we have a business or contractual
                    relationship with, including our agents, partners,
                    associates and parent or subsidiary entities. Your legal
                    situation is not evaluated when determining which law firm
                    we contact you on behalf of. You are under no obligation to
                    retain a lawyer who contacts you through this service.
                </p>
                <p>
                    By registering on the Site, you expressly request and
                    consent to be contacted by telephone (including calls to
                    your mobile phone), email, text message, letter and/or fax
                    by us, our employees, representatives, agents, Third Party
                    Attorneys and third-party contracted vendors with
                    information related to your inquiry as well as other
                    promotions and offers, notwithstanding that your telephone
                    number may be listed on the Federal Trade Commission&rsquo;s
                    Do-Not-Call Registry or a state do-not-call list. You
                    expressly confirm you understand that these telephone calls,
                    emails, texts, letters and/or faxes are being made pursuant
                    to your request for such communications. You also agree that
                    the act of registering on the Site constitutes an inquiry
                    and/or application for purposes of the Amended Telemarketing
                    Sales Rule, 16 C.F.R. § 310 et seq. (&ldquo;ATSR&rdquo;).
                    YOU MAY RECEIVE CALLS THAT DELIVER AUTODIALED AND/OR
                    PRERECORDED TELEMARKETING MESSAGES. We do not charge a fee
                    to register with or use the Site. If you no longer wish to
                    receive communications from us, please follow the opt-out
                    procedures contained in our Privacy Policy. If you no longer
                    wish to receive communications from a Third Party Attorney,
                    you must follow its opt-out procedure.
                </p>
                <p>
                    <strong>SMS/Text Messaging.</strong> If you provide your
                    mobile phone number and consent, we may send you SMS/text
                    messages relating to your inquiry, appointment or
                    case-related updates, customer service and support, and
                    marketing or promotional communications about our Services.
                    Message frequency varies, and message and data rates may
                    apply. Reply STOP to unsubscribe at any time, or reply HELP
                    for assistance. Text messages are sent by Reliance
                    Litigation or its service providers acting on our behalf.
                    Consent to receive marketing text messages is not a
                    condition of purchasing any goods or services.
                    Notwithstanding anything above, no mobile information will
                    be shared with third parties or affiliates for marketing or
                    promotional purposes, and text messaging originator opt-in
                    data and consent will not be shared with any third parties.
                    You may also opt out by contacting us at
                    privacy@reliancelitigation.com.
                </p>
                <h2>6. No Legal Advice</h2>
                <p>
                    You understand that content provided on this Site is
                    advertising material only. The information and services on
                    this Site are not intended to be and should not be used as
                    legal, medical or other advice. Your use of the content,
                    information and services on this Site is at your own risk.
                    You acknowledge that under no circumstances are we providing
                    medical, legal or other advice or representation through
                    this Site, and nothing on this Site is intended as a
                    substitute for advice from an attorney, doctor or other
                    professional. Under no circumstances will we have any
                    liability to you for any reliance on information contained
                    on or obtained through this Site. You understand and agree
                    that an attorney or law firm may contact you to discuss the
                    information you submit. You agree that the information that
                    you receive in response is for general information purposes
                    and that you will not be charged for this response. You
                    further understand and agree that the laws of each state
                    vary and you will not rely upon this information as legal
                    advice. Since this matter may require advice particular to
                    your home state, you understand and agree that local counsel
                    may be contacted for referral of this matter, and that we
                    bear no responsibility for retaining local counsel or
                    otherwise as a result of your submission of contact
                    information to us.
                </p>
                <h2>7. No Endorsement of Attorneys</h2>
                <p>
                    The hiring of a lawyer is a critical decision and should not
                    be predicated solely on comments, advertisements or other
                    content found on any website. We do not endorse or recommend
                    any attorneys or law firms, nor make any representation
                    about the quality of legal services or the qualifications of
                    any attorney, law firm or legal provider. We do not analyze
                    your legal problems in determining which attorney to match
                    you with. You also understand and agree that you are solely
                    responsible for investigating any attorney or law firm that
                    contacts you and that (i) neither we, nor our Affiliates may
                    be held responsible for any claims you may have resulting
                    from the services or information you may receive; and (ii)
                    we make no representations or warranties regarding the
                    licensing, bonding or qualifications of any person who may
                    contact you based on the submission of your information to
                    us or the quality of legal services that may be provided by
                    advertising attorneys. Any results appearing on the Site are
                    specific to a particular case and do not represent a
                    guarantee or prediction of future results.
                </p>
                <h2>8. Attorney Professional Conduct</h2>
                <p>
                    If you are an attorney participating in any aspect of this
                    Site, you acknowledge that the Rules or Codes of
                    Professional Conduct (collectively &ldquo;Rules&rdquo;) of
                    the jurisdictions in which you are licensed apply to all
                    aspects of your participation and that you will abide by
                    such Rules. we disclaim all responsibility for your
                    compliance with these Rules. You warrant that content you
                    post or share will be used to provide general information
                    only, and not for the provision of legal advice or the
                    practice of law.
                </p>
                <h2>9. No Users Under 18; COPPA</h2>
                <p>
                    If you are under 18, you may not access or use the Site. BY
                    ACCESSING OR USING THE SITE, YOU REPRESENT THAT YOU ARE AT
                    LEAST 18 YEARS OLD. In compliance with COPPA, we do not
                    knowingly collect personally identifiable information from
                    users under 13.
                </p>
                <h2>10. No International Users</h2>
                <p>
                    THE SITE IS NOT OFFERED FOR USE BY PERSONS RESIDING IN
                    JURISDICTIONS OTHER THAN THE CONTINENTAL U.S. AND ALASKA AND
                    HAWAII. If you live in any location other than the 50 states
                    comprising the United States of America, you may not use the
                    Site.
                </p>
                <h2>11. Our Content and Technology</h2>
                <p>
                    &ldquo;Our Content&rdquo; means any intellectual property,
                    data, or communications transmitted by us, our users or
                    third-parties via our platforms (&ldquo;Platforms&rdquo;)
                    including, but not limited to files, images, listings,
                    logos, messages, postings, ratings, recommendations,
                    reviews, text, trademarks or editorial content. It also
                    includes all content generated by us.
                </p>
                <p>
                    &ldquo;Our Technology&rdquo; means any past, present and
                    future intellectual property or related rights in the
                    Platforms, including, but not limited to, software, code
                    processes, algorithms, user interfaces, know-how,
                    techniques, organization, designs, text, images,
                    photographs, illustrations, artwork, graphic material,
                    advertising copy, databases, proprietary information, all
                    copyrightable or otherwise legally protectable elements of
                    the Platforms and all other tangible or intangible materials
                    related to, displayed, performed, or distributed on the
                    Platforms and the Platforms themselves, including, but not
                    limited to the selection, sequence, &ldquo;look and
                    feel&rdquo; and arrangement of items on the Platforms, and
                    all of our marks, domain names, patents and other
                    intellectual property.
                </p>
                <p>
                    Unless otherwise noted, all of Our Content is owned,
                    controlled or licensed by us. Our Content is protected by
                    copyright, trademark, service mark, and/or other
                    intellectual property rights. You understand and agree that
                    you shall acquire no rights in Our Content or Our Technology
                    unless otherwise stated in writing.
                </p>
                <ol style={{ listStyleType: "lower-alpha" }}>
                    <li>
                        License to Access and/or Use. We grant you a limited,
                        personal, non-exclusive, non-transferable, freely
                        revocable license to access and/or use Our Content and
                        Our Technology to use the Site. You agree and understand
                        that with the exception of this limited license, you
                        have no rights in or to Our Content or Our Technology
                        unless otherwise stated in writing. This limited license
                        terminates automatically and without notice to you if
                        you breach this Agreement.
                    </li>
                    <p>
                        This Agreement permits you to use the Site for your
                        personal/individual use only. You must not reproduce,
                        distribute, modify, create derivative works of, publicly
                        display, publicly perform, republish, download, store or
                        transmit any of the material on our Site, except as
                        follows:
                    </p>
                    <ol>
                        <li>
                            Your computer may temporarily store copies of such
                            materials in RAM incidental to your accessing and
                            viewing those materials.
                        </li>
                        <li>
                            You may store files that are automatically cached by
                            your web browser for display enhancement purposes.
                        </li>
                        <li>
                            You may print or download one copy of a reasonable
                            number of pages of the Site for your own personal
                            use and not for further reproduction, publication or
                            distribution.
                        </li>
                        <li>
                            If we provide desktop, mobile or other applications
                            for download, you may download a single copy to your
                            computer or mobile device solely for your own
                            personal use, provided you agree to be bound by our
                            end user license agreement for such applications.
                        </li>
                    </ol>
                    <p>
                        If you print, copy, modify, download or otherwise use or
                        provide any other person with access to any part of the
                        Site in breach of this Agreement, your right to use the
                        Site will cease immediately and you must, at our option,
                        return or destroy any copies of the materials you have
                        made. No right, title or interest in or to the Site or
                        any content on the Site is transferred to you. Any use
                        of the Site not expressly permitted by this Agreement is
                        a breach of this Agreement and may violate copyright,
                        trademark and other laws.
                    </p>
                    <li>
                        Reservation of Rights. We reserve all rights not
                        expressly granted in this Agreement unless otherwise
                        stated in writing.
                    </li>
                    <li>
                        Prevention of Unauthorized Use. We reserve the right to
                        employ whatever lawful means we consider necessary to
                        prevent unauthorized use of the Site, Our Content and/or
                        Our Technology, including, but not limited to,
                        technological barriers, IP mapping and contacting your
                        Internet Service Provider (ISP).
                    </li>
                </ol>
                <h2>12. Prohibitions on Use</h2>
                <p>
                    You may not do or encourage any of the following actions on
                    the Site:
                </p>
                <ol style={{ listStyleType: "lower-alpha" }}>
                    <li>
                        Sell, resell, lease, sublicense, market, distribute,
                        assign or otherwise transfer rights to or commercially
                        exploit any portion of the Site;
                    </li>
                    <li>
                        Take any action that imposes an unreasonable or
                        disproportionately large load on the Site&rsquo;s
                        infrastructure;
                    </li>
                    <li>
                        &ldquo;Scrape&rdquo; the Site, or use any bot, spider,
                        data miner or automated agent to access and/or use the
                        Site or gain access to or use any of Our Content;
                    </li>
                    <li>
                        Reformat, modify, translate or create derivative works
                        of or display any portion of the Site, or mirror and/or
                        frame any pages of the Site on any other website;
                    </li>
                    <li>
                        Attempt to decipher, decompile, disassemble, or reverse
                        engineer any of Our Technology;
                    </li>
                    <li>
                        Forge headers or otherwise manipulate identifiers in
                        order to disguise or alter the origin of any content
                        transmitted through the services or develop restricted
                        or password-only access pages, or hidden pages or images
                        (those not linked to from another accessible page);
                    </li>
                    <li>
                        Upload, post or otherwise transmit any content that you
                        do not have a right to transmit under any law or under
                        contractual or fiduciary relationships (such as inside
                        information, proprietary and confidential information
                        learned or disclosed as part of employment relationships
                        or under nondisclosure agreements);
                    </li>
                    <li>
                        Upload, post or otherwise transmit any material that
                        contains software viruses or any other computer code,
                        files or programs designed to interrupt, destroy or
                        limit the functionality of any computer software or
                        hardware or telecommunications equipment;
                    </li>
                    <li>
                        Attempt to gain unauthorized access to any services,
                        accounts, computer systems or networks connected to any
                        server used for this Site, through password mining,
                        hacking or any other means;
                    </li>
                    <li>
                        Use any framing techniques to enclose any portion of
                        this Site (including, but not limited to, images, text,
                        page layout and form) without our prior written consent;
                    </li>
                    <li>
                        Make any use of the trademarks, service marks, trade
                        names, logos and graphics on this Site without our prior
                        written consent.
                    </li>
                    <li>
                        Use or otherwise export or re-export this Site, or any
                        portion thereof, in violation of the export control laws
                        and regulations of the United States of America.
                    </li>
                    <li>
                        Remove or interfere with any of Our Content, Our
                        Technology or any other proprietary right of the Site;
                        or
                    </li>
                    <li>
                        Use the Site: (i) for any unlawful purpose, (ii) to
                        defraud or mislead us or any third-party, or (iii) to
                        create damage or risk to us or any third-party business,
                        network or facility.
                    </li>
                </ol>
                <h2>13. Third-Party Links</h2>
                <p>
                    The Site may provide links to other sites (each a
                    &ldquo;linked site&rdquo;) and allow you to leave the Site
                    to access third-party material or bring third-party material
                    to the site via &ldquo;inverse&rdquo; hyperlinks and framing
                    technology. We have no discretion to alter, update, or
                    control the content of a linked site. The fact that we have
                    provided a link to a linked site is not an endorsement,
                    authorization, sponsorship, or affiliation with respect to
                    such linked site, its owners, or its providers. There are
                    inherent risks in relying upon using, or retrieving any
                    information found on the Internet, and we urge you to make
                    sure you understand these risks before relying upon, using,
                    or retrieving any such information on a linked site. We are
                    not responsible, and assume no liability, for any mistakes,
                    misstatements of law, defamation, slander, libel, omissions,
                    falsehood or obscenity in the statements, opinions,
                    representations or any other form of content contained in
                    any third party content appearing on or accessible from this
                    Site. You acknowledge that the information and opinions in
                    the third party content are neither endorsed, controlled by,
                    nor reflect our beliefs.
                </p>
                <h2>14. Linking to the Site</h2>
                <p>
                    You may link to the Site, provided you do so in a manner
                    that does not damage our reputation or encourage or endorse
                    any use of the Site that would breach the Agreement.
                    However, you must not establish a link in such a way as to
                    suggest any association, approval or endorsement by use
                    where none exists.
                </p>
                <h2>15. Non-Reliance on Site</h2>
                <p>
                    We may discontinue or change any of Our Content or any
                    service, function, or feature of the Site at any time with
                    or without notice.
                </p>
                <h2>16. Disclaimer of Warranties</h2>
                <ol style={{ listStyleType: "lower-alpha" }}>
                    <li>
                        YOU UNDERSTAND AND AGREE THAT WE DO NOT GUARANTEE THE
                        ACCURACY, SUITABILITY OR COMPLETENESS OF ANY INFORMATION
                        IN OR PROVIDED IN CONNECTION WITH THE SITE. WE ARE NOT
                        RESPONSIBLE FOR ANY ERRORS OR OMISSIONS OR FOR THE
                        RESULTS OBTAINED FROM THE USE OF SUCH INFORMATION.
                    </li>
                    <li>
                        WE EXPRESSLY DISCLAIM ANY AND ALL REPRESENTATIONS AND
                        WARRANTIES OF ANY KIND OR NATURE, EXPRESS OR IMPLIED,
                        INCLUDING REPRESENTATIONS AND WARRANTIES OF QUALITY,
                        MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
                        THOSE ARISING BY STATUTE OR OTHERWISE IN LAW OR FROM A
                        COURSE OF DEALING OR USE OF TRADE.
                    </li>
                    <li>
                        ANY ADVERTISERS APPEARING ON OR THROUGH THE SITE ARE NOT
                        OUR AGENTS OR EMPLOYEES AND WE ARE NOT LIABLE FOR THE
                        ACTS, ERRORS, OMISSIONS, REPRESENTATIONS, WARRANTIES,
                        BREACHES OR NEGLIGENCE OF ANY ENTITY OR SERVICE
                        APPEARING ON OR AVAILABLE THROUGH THE SITE, INCLUDING
                        BUT NOT LIMITED TO INJURIES, DEATH, PROPERTY DAMAGE OR
                        OTHER DAMAGES OR EXPENSES RESULTING THEREFROM.
                    </li>
                    <li>
                        WE DO NOT REPRESENT OR WARRANT THAT: (i) THE SITE WILL
                        MEET USERS&rsquo; REQUIREMENTS OR EXPECTATIONS, (ii) THE
                        SITE WILL BE ERROR-FREE OR UNINTERRUPTED OR THAT
                        INFORMATION OBTAINED WILL BE ACCURATE OR RELIABLE, OR
                        (iii) THAT ALL DEFICIENCIES IN THE SERVICE CAN BE FOUND
                        OR CORRECTED. FURTHER, THE SITE MAY BE INTERRUPTED OR
                        UNAVAILABLE FOR THE PURPOSES OF PERFORMING MAINTENANCE
                        OR UPGRADES. WE WILL NOT BE RESPONSIBLE FOR: (1) SERVICE
                        IMPAIRMENTS CAUSED BY ACTS WITHIN THE CONTROL OF USER OR
                        ANY USER, (2) INTEROPERABILITY OF SPECIFIC USER
                        APPLICATIONS OR EQUIPMENT, (3) INABILITY OF USERS TO
                        ACCESS OR INTERACT WITH ANY OTHER SERVICE PROVIDER
                        THROUGH THE INTERNET, OTHER NETWORKS OR USERS THAT
                        COMPRISE THE INTERNET OR THE INFORMATIONAL OR COMPUTING
                        RESOURCES AVAILABLE THROUGH THE INTERNET, (4)
                        INTERACTION WITH OTHER SERVICE PROVIDERS, NETWORKS,
                        USERS OR INFORMATIONAL OR COMPUTING RESOURCES THROUGH
                        THE INTERNET, (5) SERVICE PROVIDED BY OTHER SERVICE
                        PROVIDERS, OR (6) PERFORMANCE IMPAIRMENTS CAUSED
                        ELSEWHERE ON THE INTERNET.
                    </li>
                    <li>
                        WE DO NOT WARRANT THAT THE SERVICE OR ITS OPERATION WILL
                        BE ACCURATE, RELIABLE, UNINTERRUPTED, ERROR-FREE OR FREE
                        OF VIRUSES OR OTHER HARMFUL AGENTS.
                    </li>
                </ol>
                <h2>17. Limitation of Liability</h2>
                <ol style={{ listStyleType: "lower-alpha" }}>
                    <li>
                        IN NO EVENT, INCLUDING NEGLIGENCE, WILL WE OR ANYONE
                        ELSE INVOLVED IN ADMINISTERING THE SITE BE LIABLE FOR
                        ANY DIRECT, SPECIAL, INCIDENTAL, INDIRECT, OR
                        CONSEQUENTIAL LOSS OR DAMAGE, LOSS OF DATA, DAMAGES FOR
                        DELAY, PUNITIVE OR EXEMPLARY DAMAGES, OR ANY CLAIM
                        AGAINST USER BY ANY OTHER PERSON RESULTING FROM
                        MISTAKES, OMISSIONS, SERVICE INTERRUPTIONS, SERVER
                        DOWNTIME, ERRORS, DEFECTS, VIRUSES, DELAYS IN OPERATION
                        OR TRANSMISSION, OR FAILURE OF PERFORMANCE OF THE
                        SERVICE, EVEN IF WE HAVE BEEN ADVISED OF THE POSSIBILITY
                        OF ANY SUCH LOSSES OR DAMAGES.
                    </li>
                    <li>
                        WE SHALL NOT BE LIABLE FOR UNAUTHORIZED ACCESS TO OR
                        ALTERATION, THEFT, LOSS OR DESTRUCTION OF ANY DATA,
                        EQUIPMENT OR SERVICES, INCLUDING THROUGH ACCIDENT,
                        FRAUDULENT MEANS OR DEVICES, OR ANY OTHER METHOD.
                    </li>
                    <li>
                        WE SHALL BE LIABLE TO USERS ONLY AS EXPRESSLY PROVIDED
                        IN THIS AGREEMENT AND SHALL HAVE NO OTHER OBLIGATION,
                        DUTY, OR LIABILITY WHATSOEVER IN CONTRACT, TORT
                        (INCLUDING BUT NOT LIMITED TO NEGLIGENCE) OR OTHERWISE
                        TO USER. THE LIMITATIONS, EXCLUSIONS AND DISCLAIMERS IN
                        THIS AGREEMENT SHALL APPLY IRRESPECTIVE OF THE NATURE OF
                        THE CAUSE OF ACTION, DEMAND, OR ACTION BY USER,
                        INCLUDING BREACH OF CONTRACT, NEGLIGENCE, TORT, OR ANY
                        OTHER LEGAL THEORY AND SHALL SURVIVE A FUNDAMENTAL
                        BREACH OR BREACHES OR THE FAILURE OF THE ESSENTIAL
                        PURPOSE OF THIS AGREEMENT OR OF ANY REMEDY CONTAINED
                        HEREIN. SOME STATES AND JURISDICTIONS DO NOT ALLOW
                        LIMITATIONS ON DURATION OR THE EXCLUSION OF AN IMPLIED
                        WARRANTY, OR MAY PROVIDE ADDITIONAL RIGHTS THAT MAY NOT
                        BE WAIVED PURSUANT TO THIS DOCUMENT.
                    </li>
                    <li>
                        YOU HEREBY ACKNOWLEDGE THAT WE ARE NOT RESPONSIBLE FOR
                        ANY INTERCEPTED INFORMATION SENT VIA THE INTERNET, AND
                        YOU HEREBY RELEASE US FROM ANY AND ALL CLAIMS ARISING
                        OUT OF OR RELATED TO THE USE OF INTERCEPTED INFORMATION
                        IN ANY UNAUTHORIZED MANNER.
                    </li>
                    <li>
                        USERS WHO RESIDE IN CALIFORNIA AGREE TO WAIVE CALIFORNIA
                        CIVIL CODE SECTION 1542, WHICH STATES &ldquo;A GENERAL
                        RELEASE DOES NOT EXTEND TO CLAIMS WHICH THE CREDITOR
                        DOES NOT KNOW OR SUSPECT TO EXIST IN HIS OR HER FAVOR AT
                        THE TIME OF EXECUTING THE RELEASE, WHICH IF KNOWN BY HIM
                        OR HER MUST HAVE MATERIALLY AFFECTED HIS OR HER
                        SETTLEMENT WITH THE DEBTOR.&rdquo;
                    </li>
                    <li>
                        TO THE FULLEST EXTENT POSSIBLE BY LAW, OUR MAXIMUM
                        LIABILITY ARISING OUT OF OR IN CONNECTION WITH THE SITE
                        OR YOUR USE OF OUR CONTENT, REGARDLESS OF THE CAUSE OF
                        ACTION (WHETHER IN CONTRACT, TORT, BREACH OF WARRANTY OR
                        OTHERWISE), WILL NOT EXCEED ONE-HUNDRED DOLLARS
                        ($100.00).
                    </li>
                </ol>
                <h2>18. Indemnification</h2>
                <p>
                    You agree to indemnify and hold us, our affiliates,
                    employees and members (each an &ldquo;Indemnitee&rdquo;)
                    harmless from and against any claims, suits, actions or
                    proceedings (&ldquo;Claims&rdquo;) brought and damages,
                    costs (including attorneys&rsquo; fees) and/or judgments
                    awarded against us that arise from or in connection with:
                    (i) Claims by any person or entity to the extent that such
                    Claims are based upon or arise out of user&rsquo;s use of
                    the Site or user&rsquo;s actions, (ii) breach by user of
                    this Agreement, or (iii) user&rsquo;s failure to comply with
                    all applicable laws. We shall give user written notice of
                    such Claims, permit user to defend (with counsel reasonably
                    acceptable to us) and/or settle such Claims (upon terms
                    reasonably acceptable to us), and, subject to our sole
                    discretion, give user information and assistance reasonably
                    requested by user in connection with such Claims.
                </p>
                <h2>19. As Is, With All Faults</h2>
                <p>
                    The Site is provided on an &ldquo;AS IS&rdquo; and
                    &ldquo;WITH ALL FAULTS&rdquo; basis. Content, advertising,
                    sponsorships, promotions and other information made
                    available on the Site are provided for your reference only.
                </p>
                <h2>20. Survival</h2>
                <p>
                    The provisions of this Agreement that by their nature are
                    intended to survive the expiration or earlier termination,
                    including those provisions relating to ownership,
                    indemnification/defense, warranty disclaimer, and limits of
                    liability shall survive the expiration or earlier
                    termination of this Agreement.
                </p>
                <h2>21. Miscellaneous</h2>
                <ol style={{ listStyleType: "lower-alpha" }}>
                    <li>
                        Notice. We may give notice by means of a general notice
                        through the Site or via email at any address you have
                        provided us. You may give notice to us at any time by
                        any of the following: email with confirmed receipt to
                        info@reliancelitigation.com or letter delivered by
                        nationally recognized overnight delivery service to the
                        following address: Reliance Litigation, LLC, 21550
                        Oxnard St, FL 3, Woodland Hills, CA 91367.
                    </li>
                    <li>
                        Force Majeure. If the performance of this Agreement, or
                        any obligation hereunder is prevented, restricted, or
                        interfered with by reason of fire, flood, earthquake,
                        explosion or other casualty or accident or act of God,
                        strikes or labor disputes, inability to procure or
                        obtain delivery of items, supplies, telecommunication
                        services, equipment or software, war or other violence,
                        any law, order, proclamation, regulation, ordinance,
                        demand or requirement of any governmental authority, or
                        any other act or condition whatsoever beyond our
                        reasonable control, we shall be excused from such
                        performance to the extent of such prevention.
                    </li>
                    <li>
                        Severability. To the extent that any provision or
                        portion of this Agreement is deemed to be invalid,
                        illegal or unenforceable, such provision or portion
                        shall be severed and deleted or limited so as to give
                        effect to the intent of the parties insofar as possible
                        and the remainder of this Agreement, as the case may be,
                        shall remain binding upon the parties.
                    </li>
                    <li>
                        Assignment. User may not, without our prior written
                        consent (which may be given or withheld in our sole
                        discretion), assign or transfer this Agreement or any of
                        its rights or obligations under this Agreement to any
                        third-person. We may assign this Agreement to any person
                        or entity without your consent. We may delegate to our
                        affiliates, agents, suppliers and contractors any of the
                        obligations herein imposed upon us and we may disclose
                        to any such persons any information required by them to
                        perform the duties so delegated to them.
                    </li>
                    <li>
                        Waiver. A failure or delay by us to enforce any right
                        under this Agreement shall not at any time constitute a
                        waiver of such right or any other right, and shall not
                        modify the rights or obligations of either party under
                        this Agreement.
                    </li>
                    <li>
                        Governing Law. This Agreement shall be governed by and
                        construed in accordance with the laws of the State of
                        California without reference to conflict or choice of
                        law rules or principles.
                    </li>
                    <li>
                        Arbitration. ANY DISPUTE, CONTROVERSY OR CLAIM ARISING
                        OUT OF, RELATING TO OR IN CONNECTION WITH THIS
                        AGREEMENT, INCLUDING THE BREACH, TERMINATION OR VALIDITY
                        THEREOF, SHALL BE FINALLY RESOLVED BY ARBITRATION OR
                        SMALL CLAIMS COURT. The arbitration tribunal shall have
                        the power to rule on any challenge to its own
                        jurisdiction or to the validity or enforceability of any
                        portion of the agreement to arbitrate. THE PARTIES AGREE
                        TO ARBITRATE SOLELY ON AN INDIVIDUAL BASIS, AND THAT
                        THIS AGREEMENT DOES NOT PERMIT CLASS ARBITRATION OR ANY
                        CLAIMS BROUGHT AS A PLAINTIFF OR CLASS MEMBER IN ANY
                        CLASS OR REPRESENTATIVE ARBITRATION PROCEEDING. We will
                        cover the initial costs of arbitration with a consumer
                        claimant. The arbitration may take place in the
                        consumer&rsquo;s home county at consumer&rsquo;s
                        election. The arbitral tribunal may not consolidate more
                        than one person&rsquo;s claims, and may not otherwise
                        preside over any form of a representative or class
                        proceeding. If a portion of the agreement to arbitrate
                        is found invalid or unenforceable, the remaining
                        portions of the arbitration agreement will remain in
                        force except in the event that class arbitration is
                        requested and the prohibition on class arbitration is
                        found invalid or unenforceable. In such event the entire
                        agreement to arbitrate will be null and void.
                    </li>
                    <li>
                        Non-Arbitration Forum; Venue. In the event that a
                        challenge to the jurisdiction of the arbitrator or a
                        challenge to the validity or enforceability of any
                        portion of the agreement to arbitrate is sustained, the
                        parties irrevocably and unconditionally submit to the
                        exclusive jurisdiction of the courts of the State of
                        California located in Los Angeles County or in the
                        United States District Court for the Central District of
                        California for the purposes of any suit, action or other
                        proceeding arising out of this Agreement or the subject
                        matter hereof that cannot be arbitrated as the result of
                        such challenge. The parties hereby waive and agree not
                        to assert as a defense or otherwise, in any such suit,
                        action or proceeding, any claim that it is not subject
                        personally to the jurisdiction of the above-named
                        courts, that the suit, action or proceeding is brought
                        in an inconvenient forum, or that the venue of the suit,
                        action or proceeding is improper.
                    </li>
                    <li>
                        Waiver of Jury Trial and Class Suit. You acknowledge and
                        understand that, with respect to any dispute with us,
                        our affiliates, employees and members relating to or
                        arising from your use of the Site or this Agreement that
                        YOU ARE GIVING UP YOUR RIGHT TO HAVE A TRIAL BY JURY AND
                        YOU ARE GIVING UP YOUR RIGHT TO SERVE AS A
                        REPRESENTATIVE, AS A PRIVATE ATTORNEY GENERAL, OR IN ANY
                        OTHER REPRESENTATIVE CAPACITY, OR TO PARTICIPATE AS A
                        MEMBER OF A CLASS OF CLAIMANTS, IN ANY LAWSUIT INVOLVING
                        SUCH DISPUTE.
                    </li>
                    <li>
                        Miscellaneous. All covenants, agreements,
                        representations and warranties made in this Agreement
                        shall survive your acceptance of this Agreement and the
                        termination of this Agreement.
                    </li>
                    <li>
                        Construction. The titles of the sections of this
                        Agreement are for convenience of reference only and are
                        not to be considered in construing any meanings
                        contained in this Agreement. Unless the context of this
                        Agreement clearly requires otherwise: (i) references to
                        the plural include the singular, the singular the
                        plural, and the part the whole, (ii) references to one
                        gender include all genders, (iii) &ldquo;or&rdquo; has
                        the inclusive meaning frequently identified with the
                        phrase &ldquo;and/or,&rdquo; (iv)
                        &ldquo;including&rdquo; has the inclusive meaning
                        frequently identified with the phrase &ldquo;including
                        but not limited to&rdquo; or &ldquo;including without
                        limitation,&rdquo; and (v) references to
                        &ldquo;hereunder,&rdquo; &ldquo;herein&rdquo; or
                        &ldquo;hereof&rdquo; relate to this Agreement as a
                        whole. Any reference in this Agreement to any statute,
                        rule, regulation or agreement, including this Agreement,
                        shall be deemed to include such statute, rule,
                        regulation or agreement as it may be modified, varied,
                        amended or supplemented from time to time. The parties
                        agree that this Agreement shall be fairly interpreted in
                        accordance with its terms without any strict
                        construction in favor of or against either party, and
                        that ambiguities shall not be interpreted against the
                        drafting party.
                    </li>
                    <li>
                        Attorneys&rsquo; Fees. If a challenge to the
                        jurisdiction of the arbitrator or a challenge to the
                        validity or enforceability of any portion of the
                        agreement to arbitrate is sustained and a lawsuit
                        between you and us is necessary in order to enforce any
                        of the terms of this Agreement, the prevailing party in
                        any such action shall be entitled to recover its
                        reasonable attorneys&rsquo; fees and costs from the
                        non-prevailing party.
                    </li>
                    <li>
                        Relationship. This Agreement creates no agency,
                        partnership, joint venture, or employee-employer
                        relationship between you and us, unless otherwise stated
                        in writing by us.
                    </li>
                    <li>
                        Entire Agreement. This Agreement sets forth the entire
                        agreement of the parties, and supersedes any prior
                        agreement and any prior discussion between the parties,
                        relating to the subject matter contained herein. Neither
                        party shall be bound by any definition, condition,
                        provision, representation, warranty, covenant or promise
                        other than as expressly stated in this Agreement or as
                        contemporaneously or subsequently set forth in writing
                        and signed by a duly authorized officer or
                        representative of the party to be bound thereby.
                    </li>
                </ol>
                <h2>22. Contact Us</h2>
                <p>
                    Any comments or requests for further information may be
                    directed to:
                    <br />
                    <strong>Reliance Litigation LLC,</strong>
                    <br />
                    21550 Oxnard St, FL 3<br />
                    Woodland Hills, CA 91367
                </p>
            </div>
        </div>
    );
}

export default Terms;
